import { render, staticRenderFns } from "./NotificationMarkAsRead.vue?vue&type=template&id=5f5dab45&scoped=true"
import script from "./NotificationMarkAsRead.vue?vue&type=script&lang=ts"
export * from "./NotificationMarkAsRead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5dab45",
  null
  
)

export default component.exports